import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import de from './locales/de/translation.json';

const bundledResources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  de: { translation: de },
};

const isProduction = process.env.NODE_ENV === 'production';

const i18nInstance = i18n.createInstance();

i18nInstance.use(LanguageDetector).init({
  debug: !isProduction,
  fallbackLng: 'en',
  ns: ['translation'],
  defaultNS: 'translation',
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'div', 'a', 'em'],
    useSuspense: true,
  },
  // Use local resources for cloudKeyUnlockApp
  resources: bundledResources,
  saveMissing: false,
  updateMissing: false,
});

export default i18nInstance;
